<template>
    <div>
        <div class="flex justify-between items-center mb-6">
            <div class="flex cursor-pointer text-green-600 hover:text-green-700" @click="goBack">
                <i class='bx bx-left-arrow-alt bx-sm my-auto'></i>
                <p class="text-xl font-semibold d-none d-md-block">Chỉnh sửa ngành học</p>
            </div>
            <div class="flex gap-1">
                <button @click="getEntry" class="admin-refresh-btn">
                    <i class='bx bx-refresh my-auto' ></i><p>Đặt lại</p>
                </button>
                <button @click="saveAction" class="admin-save-btn">
                    <i class='bx bx-save text-white my-auto' ></i><p>Lưu</p>
                </button>
            </div>
        </div>
        <div class="entry-detail grid grid-cols-1 md:grid-cols-12 gap-4">
            <div class="md:col-span-8">
                <entryName v-model="entry" @update="(e) => (entry = e)" />
                <entryDescription class="lg:col-span-2" v-model="entry" @update="(e) => (entry = e)" />
            </div>
            <entryImage class="md:col-span-4" v-model="entry" @update="(e) => (entry = e)" />
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import entryName from './partials/entry-name.vue';
import entryImage from './partials/entry-image.vue';
import entryDescription from './partials/entry-description.vue';
export default {
    name: 'edit',
    components: {
        entryDescription, entryName, entryImage
    },
    data() {
        return {
            entry: {
                name: '',
                description: '',
                image: ''
            }
        }
    },
    methods: {
        ...mapActions('cooperation', ['GetCooperation', 'UpdateCooperation']),
        saveAction() {
            let validate = {
                name: 'Tên doanh nghiệp',
                image: 'Hình ảnh',
                description: 'Mô tả',
            };
            if (!this.$validator(this.entry, validate)) return
            this.$swal.fire({
            title: 'Sửa chi tiết ngành học?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sửa!',
            cancelButtonText: 'Hủy'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await this.UpdateCooperation(this.entry);
                    this.goBack()
                }
            })
        },
        goBack() {
            this.$router.push({
				name: "admin." + this.$route.name.split(".")[1],
			});
        },
        async getEntry() {
            let response = await this.GetCooperation(this.$route.params.id)
            this.entry = response.data
        }
    },
    created() {
        this.getEntry()
    }
}
</script>
<style>
.entry-detail .form-group {
    margin-bottom: 0;
}
</style>